<template>
  <nav class="footer">
    <router-link to="/"><img src="../assets/icons/home.svg" @click="$root.modalOpen = false;"></router-link>
    <burger-menu/>
  </nav>
</template>

<style scoped>
nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding:15px;
  height: 50px;
  background-color: white;
  box-shadow: var(--footer-shadow);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10000;
}
a.router-link-exact-active {
  opacity: .2;
}
</style>
<script>
import BurgerMenu from './BurgerMenu';
export default {
  components: { BurgerMenu }
}
</script>